require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-investing-for-the-future.json") })
        }
      }, "path---insights-investing-for-the-future");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-investing-for-the-future!./.cache/json/insights-investing-for-the-future.json
// module id = 1097
// module chunks = 231608221292675